import { useState } from 'react'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { queueMachineService } from '@/services/queue_machine_service'
import { useAuth } from '@/hooks/useAuth'
import { toast } from 'sonner'
import { QueueMachineWithRelations } from '@magnetar/admin-api-interfaces'

interface DeleteQueueMachineDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  queueMachine: QueueMachineWithRelations
  onSuccess?: () => void
}

export function DeleteQueueMachineDialog({
  open,
  onOpenChange,
  queueMachine,
  onSuccess,
}: DeleteQueueMachineDialogProps) {
  const { token } = useAuth()
  const [isDeleting, setIsDeleting] = useState(false)

  const handleDelete = async () => {
    if (!token) return

    try {
      setIsDeleting(true)
      const result = await queueMachineService.deleteQueueMachine(
        queueMachine.queue_machine_id,
        token,
      )

      if (result.success) {
        toast.success('刪除叫號機成功')
        onOpenChange(false)
        onSuccess?.()
      } else {
        toast.error('刪除叫號機失敗')
      }
    } catch {
      toast.error('刪除叫號機時發生錯誤，請稍後再試。')
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>確認刪除</DialogTitle>
          <DialogDescription>
            確定要刪除叫號機 <span className="font-semibold">{queueMachine.name}</span>{' '}
            嗎？此操作無法復原。
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isDeleting}>
            取消
          </Button>
          <Button variant="destructive" onClick={handleDelete} disabled={isDeleting}>
            {isDeleting ? '刪除中...' : '確認刪除'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
